import React, { Component } from 'react';
import { Route, Router, Routes,useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from './components/Home/Layout';
import { Home } from './components/Home/Home';
import { Counter } from './components/Home/Counter';
import './assets/styles/custom.css'
import { Login } from './components/Home/Login';
import {Access} from './components/Home/Access';
import {AccessNew} from './components/Home/AccessNew';
import Map from './components/Home/Map.js'; 
import Analytics from './components/Home/Analytics.js';
import PowerbiAnalytics from './components/Home/PowerbiAnalytics.js';
import PowerBi from './components/Home/Powerbi.js';
import PdmcAnalyticA from './components/Home/PdmcAnalyticA';
import PdmcAnalyticB from './components/Home/PdmcAnalyticB';
import PdmcAnalyticC from './components/Home/PdmcAnalyticC';
import Dashboard from './components/Cropic/Dashboard';
import MapView from './components/Cropic/MapView';
import CropSurveyDetails from './components/Cropic/CropSurveyDetails';
import AdminHeader from './components/Common/AdminHeader';
import AdminSideBar from './components/Common/AdminSideBar';
import { NavMenu } from './components/Home/NavMenu';
import { InnerNavMenu } from './components/Home/InnerNavMenu';
import { SecondInnerNavMenu } from './components/Home/SecondInnerNavMenu';
import MapDash from './components/Home/GISDashboard';
import GISDashboard from './components/Home/GISDashboard';
//import MyForm from './components/Master/Forms';
import Crop from './components/Master/Crops';
import Season from './components/Master/Seasons';
import AddNewUser from './components/UserManagement/AddNewUser';
import IUUserMapping from './components/UserManagement/IUUserMapping';
import IUUser from './components/UserManagement/IUUser';
import Scheme from './components/Master/Scheme';
import Forms from './components/UserManagement/Forms';
import Users from './components/UserManagement/Users';
import Menu from './components/UserManagement/Menu';
import AddNewMenu from './components/UserManagement/AddNewMenu';
import UserRole from './components/UserManagement/UserRole';
import CropCategory from './components/Master/CropCategory';
import CropStages from './components/Master/CropStages';
import CropsIntervalDays from './components/Master/CropsIntervalDays';
import AddCropsIntervalDays from './components/Master/AddCropsIntervalDays';
import AddNewCrop from './components/Master/AddNewCrop';
import UserType from './components/UserManagement/UserType';
import UserRoleList from './components/UserManagement/UserRoleList';
import FormsList from './components/UserManagement/FormsList';
import RoleFormMapping from './components/UserManagement/RoleFormMapping';
import AddNewRoleForm from './components/UserManagement/AddNewRoleForm';
import CropSurveyView from './components/Cropic/CropSurveyView';
import Schemes from './components/Home/Schemes';
import AboutUs from './components/Home/AboutUs';
import ContactUs from './components/Home/ContactUs';
import Downloads from './components/Home/Downloads';

import HomeMap from './components/Home/HomeMap.js';
import { MapLogin } from './components/Home/MapLogin';
import MapHeader from './components/Common/MapHeader';
import AdminAccess from './components/Home/AdminAccess';
import SchemeReports from './components/Home/SchemeReports';
import SurveyData from './components/Home/SurveyData';
import MapNew from './components/Home/MapNew.js';
// import GIS from './components/gis/GIS.jsx';
import BhuwanNewGen from './components/gis/BHUWAN_NEW_GEN.jsx';
import Km2 from './components/Km2';

// Common Routes
import MasterLogin from './components/Common/MasterLogin';

// NewAdminPanel Routes

import NewAdminDashboard from './components/NewAdminPanel/Dashboard';
import AdminAllocatedcase from './components/NewAdminPanel/Allocatedcase';
import AdminAssetsNmeo from './components/NewAdminPanel/AssetsNmeos.js';
import AdminAssetsNmeop from './components/NewAdminPanel/assetsNmeop.js';
import AdminSideBarNew from './components/NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from './components/NewAdminPanel/Common/AdminFooter';
import AdminHeaderNew from './components/NewAdminPanel/Common/AdminHeader';
import UserCreation from './components/NewAdminPanel/UserCreation';
import AssignTarget from './components/NewAdminPanel/AssignTarget';
import UserList from './components/NewAdminPanel/UserList';
import Farmer from './components/NewAdminPanel/Farmer';
import SeedDemonstration from './components/NewAdminPanel/SeedDemonstration';
import AssetsReports from './components/NewAdminPanel/AssetsReports';
import AssetsReportOp from './components/NewAdminPanel/AssetsReportOp';
import Survey from './components/Scheme/Survey';
import CentralGT from './components/NewAdminPanel/CentralLogin';
import CompanyGT from './components/NewAdminPanel/CompanyLogin';
import CropDetailView from './components/NewAdminPanel/CropDetailView';
import GeoJsonShow from './components/NewAdminPanel/GeoJsonShow.js';
import NMEOOSDeatilPage from './components/NewAdminPanel/NMEOOSDeatilPage';
import SelfAssignedTarget from './components/NewAdminPanel/SelfAssignTarget';

/*Nature pages start*/
import AdminSideBarNature from './components/Nature/Common/AdminHeader';
import DashboardNature from './components/Nature/Dashboard';
import AdminHeaderNature from './components/Nature/Common/AdminHeader';
import CropSurvey from './components/Nature/CropSurvey';
import ProtectedRouteNatural from './components/Nature/ProctectedRouteNatural'
import SingleCropSurveyView from './components/Nature/SingleCropSurveyView'

/*NFSM pages start*/
import AdminSideBarNFSM from './components/NSFM/Common/AdminSideBar';
import DashboardNFSM from './components/NSFM/Dashboard'
import AdminHeaderNFSM from './components/NSFM/Common/AdminHeader';
import CropDemonstration from './components/NSFM/CropDemonstration';
import ProtectedRouteNFSM from './components/NSFM/ProctectedRouteNFSM'
import SingleCropDemonstrationView from './components/NSFM/SingleCropDemonstrationView'

import ProtectedRoute from './ProtectedRoute';

// Inspection Routes
import InspectionDashboard from './components/Inspection/InspectionDashboard';
import InspectionDetails from './components/Inspection/InspectionDetails';
import InspectionMap from './components/Inspection/InspectionMap';
import SingleInspectionView from './components/Inspection/SingleInspectionView';

// NHB Routes
import NHBDashboard from './components/NHB/NHBDashboard';
import NHBDetails from './components/NHB/NHBDetails';
import NHBMap from './components/NHB/NHBMap';
import SingleNHBView from './components/NHB/SingleNHBView';
//MNT
import DashboardMnT from './components/MNT/DashboardMnT';
import AdmLogin from './components/MNT/AdmLogin';
import UsrListMnt from './components/MNT/UsrListMnT';
import FmtcUserCreation from './components/MNT/FmtcUserCreation';
import AtariUserCreation from './components/MNT/AtariUserCreation';
import CrmSurveyorCreation from './components/MNT/CrmSurveyorCreation';
import FmttiSurveyorCreation from './components/MNT/FmttiSurveyorCreation';
import KvkUserCreation from './components/MNT/KvkUserCreation';
import StateUser from './components/MNT/StateUser.js';
import DistrictUserCreation from './components/MNT/DistrictUserCreation';
import CHCDetailView from './components/MNT/DashboardComponents/CHCDetailView';
import ExpMachineryDetailView from './components/MNT/DashboardComponents/ExpMachineryDetailView';
import SurveyorDetailView from './components/MNT/DashboardComponents/SurveyorDetailView';
import SurveyDetail from './components/MNT/SurveyDetail';
import MachinSurveyReport from './components/MNT/MachinSurveyReport';
import IndividualCrmSurvey from './components/MNT/IndividualCrmSurvey';     
import CRMCHCUpdatedData from './components/MNT/CRMCHCUpdatedData';
import UpdatedCRMCHCStateWise from './components/MNT/updatedCRMCHCStateWise';
import KVKWiseData from './components/MNT/KVKWiseData';
// CDP Routes
import CDPDashboard from './components/CDP/CDPDashboard';
import CDPDetails from './components/CDP/CDPDetails';
import CDPMap from './components/CDP/CDPMap';
import SingleCDPView from './components/CDP/SingleCDPView';

// GCES Routes
// import GCESDashboard from './components/GCES/GCESdashboard';
// import CentralOfficer from './components/GCES/CentralOfficer';
// import StateOfficer from './components/GCES/StateOfficer';
// import DistrictOfficer from './components/GCES/DistrictOfficer';
// import AddCentralOfficer from './components/GCES/AddCentralOfficer';
// import AddStateOfficer from './components/GCES/AddStateOfficer';
// import AddDistrictOfficer from './components/GCES/AddDistrictOfficer';
import SeedDistribution from './components/NSFM/SeedDistribution';
import SeedHubs from './components/NSFM/SeedHubs';
import Demo from './components/UserManagement/Demo';
import Designation from './components/Master/Designation';
import OrganizationLevel from './components/Master/OrganizationLevel';
import SchemePMFBY from './components/Master/SchemePMFBY';
import UploadSurveyLocation from './components/UserManagement/UploadSurveyLocation';
import FarmerDetailView from './components/NewAdminPanel/FarmerDetailView';
import NFSMScheme from './components/Home/NFSMScheme';
import NMEOScheme from './components/Home/NMEOScheme';
import NMEOScheme3F from './components/Home/NMEOScheme3F';
import NFSMCFLDWiseReport from './components/Home/NFSMCFLDWiseReport';
import NFSMFarmersOutcomesUploadedReport from './components/Home/NFSMFarmersOutcomesUploadedReport';
import FarmerandCropwiseReport from './components/Home/FarmerandCropwiseReport';

import NaturalFarmingAnalytic from './components/AnalyticDashboards/AnalyticNaturalFarming/NaturalFarmingAnalytic';
import "bootstrap-icons/font/bootstrap-icons.css";
import GISHome from './components/gis/GIS_home.jsx';

import LoaderComponent from './components/gis/LoaderComponent.js';


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,   // 5 min tak data fresh rahega
            gcTime:    10 * 60 * 1000,  // 10 min tak cache mein rahega
            retry: 1,                   // fail hone par sirf ek baar retry
            refetchOnWindowFocus: false, // window focus par auto refetch band
        },
    },
});

// Wrapper to force Farmer remount when path or header changes
const FarmerRouteElement = () => {
  const location = useLocation();
  const viewSignature = `${location.pathname}|${location.state?.header || ''}`;
  return <Farmer key={viewSignature} />;
};

export default class App extends Component {
    static displayName = App.name;

 constructor(props) {
    super(props);
    this.state = {
      stateData: null,
      districtData: null,
      loading: true,
      error: null,
    };
  }

  

    render() {
         const { stateData, districtData, loading, error } = this.state;
        return (
            <QueryClientProvider client={queryClient}>
            <>
              
                <Routes>
                    <Route exact path='/' element={<Home />} />
                    <Route exact path='homemap' element={<HomeMap />} /> 
                    <Route path='/maplogin' element={<><MapLogin /></>} /> 
                    <Route path='/mapnew' element={<ProtectedRoute><MapHeader/><MapNew  /></ProtectedRoute>} />
                    <Route path='/bhuwannewgen' element={<ProtectedRoute><MapHeader/><BhuwanNewGen  /></ProtectedRoute>} />
                    <Route path='/gisdashboard' element={<ProtectedRoute><MapHeader/><GISDashboard /></ProtectedRoute>} />
                    <Route path='/map' element={<ProtectedRoute><MapHeader/><Map /></ProtectedRoute>} />
                    <Route path='/analytics' element={<ProtectedRoute><MapHeader/><Analytics /></ProtectedRoute>} />
                    <Route path='/PowerbiAnalytics' element={<ProtectedRoute><MapHeader/><PowerbiAnalytics /></ProtectedRoute>} />
                    <Route path='/Powerbi' element={<ProtectedRoute><MapHeader/><PowerBi /></ProtectedRoute>} />
                    <Route path='/GISHome' element={<><GISHome /></>} /> 
                    {/* <Route path='/GIS' element={<><MapHeader/>{loading ? <LoaderComponent /> : <GIS stateDataTest={stateData} districtDataTest={districtData} />}</>} /> */}
                    <Route path='/login' element={<><Login /></>} />
                    <Route path='/schemes' element={<Schemes />} />
                    <Route path='/aboutUs' element={<AboutUs />} />
                    <Route path='/contactUs' element={<ContactUs />} />
                    <Route path='/masterlogin' element={<MasterLogin />} /> 
                    <Route path='/adminaccess' element={<ProtectedRoute><MapHeader/><AdminAccess /></ProtectedRoute>} />  
                    <Route path='/schemereports' element={<ProtectedRoute><MapHeader/><SchemeReports /></ProtectedRoute>} /> 
                    <Route path='/nfsmscheme' element={<ProtectedRoute><MapHeader/><NFSMScheme /></ProtectedRoute>} />  
                    <Route path='/nmeoscheme' element={<ProtectedRoute><MapHeader/><NMEOScheme /></ProtectedRoute>} />  
                    <Route path='/nmeoscheme3f' element={<ProtectedRoute><MapHeader/><NMEOScheme3F/></ProtectedRoute>} />  
                    <Route path='/nfsmcfldwisereport' element={<ProtectedRoute><MapHeader/><NFSMCFLDWiseReport /></ProtectedRoute>} />                    
                    <Route path='/nfsmfarmersoutcomesuploadedreport' element={<ProtectedRoute><MapHeader/><NFSMFarmersOutcomesUploadedReport /></ProtectedRoute>} /> 
                    <Route path='/farmerandcropwisereport' element={<ProtectedRoute><MapHeader/><FarmerandCropwiseReport /></ProtectedRoute>} /> 
                    <Route path='/pdmcanalyticA' element={<ProtectedRoute><MapHeader/><PdmcAnalyticA /></ProtectedRoute>} />
                    <Route path='/pdmcanalyticB' element={<ProtectedRoute><MapHeader/><PdmcAnalyticB /></ProtectedRoute>} />
                    <Route path='/pdmcanalyticC' element={<ProtectedRoute><MapHeader/><PdmcAnalyticC /></ProtectedRoute>} />
                    <Route path='/MapDash' element={<><MapDash /></>} />

                    {/* Admin panel routes */}
                    <Route path='/cropic/dashboard' element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path='/cropic/mapview' element={<ProtectedRoute><MapView /></ProtectedRoute>} />
                    <Route path='/cropic/cropsurveydetails' element={<ProtectedRoute><CropSurveyDetails /></ProtectedRoute>} />
                    <Route path='/cropic/cropsurveyview' element={<ProtectedRoute><CropSurveyView /></ProtectedRoute>} />
                    <Route path='home/access' element={<ProtectedRoute><Access /></ProtectedRoute>} />
                    <Route path='home/accessNew' element={<AccessNew />} />
                    <Route path='home/surveydata' element={<SurveyData />} />
                    <Route path='/master/crop' element={<ProtectedRoute><Crop /></ProtectedRoute>} />
                    <Route path='/master/AddNewCrop' element={<ProtectedRoute><AddNewCrop/></ProtectedRoute>} /> 
                    <Route path='/master/cropstage' element={<ProtectedRoute><CropStages /></ProtectedRoute>} />
                    <Route path='/master/designation' element={<ProtectedRoute><Designation /></ProtectedRoute>} />
                    <Route path='/master/organizationlevel' element={<ProtectedRoute><OrganizationLevel /></ProtectedRoute>} />
                    <Route path='/master/seasons' element={<ProtectedRoute><Season /></ProtectedRoute>} />
                    <Route path='/master/cropcategory' element={<ProtectedRoute><CropCategory /></ProtectedRoute>} />
                    <Route path='/master/scheme' element={<ProtectedRoute><Scheme /></ProtectedRoute>} />
                    <Route path='/master/scheme-pmfby' element={<ProtectedRoute><SchemePMFBY /></ProtectedRoute>} />
                    <Route path='/master/cropinterval' element={<ProtectedRoute><CropsIntervalDays/></ProtectedRoute>} />
                    <Route path='/master/AddcropsIntervalDays' element={<ProtectedRoute><AddCropsIntervalDays/></ProtectedRoute>} /> 
                    <Route path='/usermanagement/forms' element={<ProtectedRoute><FormsList/></ProtectedRoute>} />
                    <Route path='/usermanagement/menu' element={<ProtectedRoute><Menu /></ProtectedRoute>} />
                    <Route path='/usermanagement/addnewmenu' element={<ProtectedRoute><AddNewMenu /></ProtectedRoute>} />
                    <Route path='/usermanagement/userrole' element={<ProtectedRoute><UserRole /></ProtectedRoute>} />
                    <Route path='/usermanagement/users' element={<ProtectedRoute><Users /></ProtectedRoute>} />
                    <Route path='/usermanagement/users/addnewuser' element={<ProtectedRoute><AddNewUser /></ProtectedRoute>} />
                    <Route path='/usermanagement/iuusermapping' element={<ProtectedRoute><IUUser /></ProtectedRoute>} />
                    <Route path='/usermanagement/iuusermapping/addnewiu' element={<ProtectedRoute><IUUserMapping /></ProtectedRoute>} />
                    <Route path='/usermanagement/usertype' element={<ProtectedRoute><UserType /></ProtectedRoute>} />
                    <Route path='/usermanagement/userrolelist' element={<ProtectedRoute><UserRoleList /></ProtectedRoute>} />
                    <Route path='/usermanagement/formslist' element={<ProtectedRoute><Forms /></ProtectedRoute>} />
                    <Route path='/usermanagement/roleformmapping' element={<ProtectedRoute><RoleFormMapping /></ProtectedRoute>} />
                    <Route path='/usermanagement/adddnewroleform' element={<ProtectedRoute><AddNewRoleForm /></ProtectedRoute>} />
                    <Route path='/usermanagement/uploadsurveylocation' element={<ProtectedRoute><UploadSurveyLocation /></ProtectedRoute>} />
                    <Route path='/master/formslist' element={<ProtectedRoute><FormsList /></ProtectedRoute>} />
                    <Route path='/usermanagement/users/addnewuser' element={<ProtectedRoute><AddNewUser /></ProtectedRoute>} />

                    {/*Nature Menus*/}
                    <Route path='/nature/dashboard' element={<ProtectedRouteNatural><DashboardNature /></ProtectedRouteNatural>} />
                    <Route path='/nature/cropsurvey' element={<ProtectedRouteNatural><CropSurvey /></ProtectedRouteNatural>} />
                    <Route path='/nature/singlecropsurveyview' element={<ProtectedRouteNatural><SingleCropSurveyView/></ProtectedRouteNatural>} />

                    {/*NFSM Menus*/}
                    <Route path='/nfsm/dashboard' element={<ProtectedRouteNFSM><DashboardNFSM /></ProtectedRouteNFSM>} />
                    <Route path='/nfsm/cropdemonstration' element={<ProtectedRouteNFSM><CropDemonstration /></ProtectedRouteNFSM>} />
                    <Route path='/nfsm/seeddistribution' element={<ProtectedRouteNFSM><SeedDistribution /></ProtectedRouteNFSM>} />
                    <Route path='/nfsm/seedhubs' element={<ProtectedRouteNFSM><SeedHubs /></ProtectedRouteNFSM>} />
                    <Route path='/nfsm/singlecropdemonstrationview' element={<ProtectedRouteNFSM><SingleCropDemonstrationView/></ProtectedRouteNFSM>} />

                    {/* INSPECTION PROTAL */}
                    <Route path='/inspection/dashboard' element={<ProtectedRoute><InspectionDashboard /></ProtectedRoute>} />
                    <Route path='/inspection/details' element={<ProtectedRoute><InspectionDetails /></ProtectedRoute>} />
                    <Route path='/inspection/map' element={<ProtectedRoute><InspectionMap/></ProtectedRoute>} />
                    <Route path='/inspection/singleinspectionview' element={<ProtectedRoute><SingleInspectionView/></ProtectedRoute>} />

                    {/* CDP PROTAL */}
                    <Route path='/cdp/dashboard' element={<ProtectedRoute><CDPDashboard /></ProtectedRoute>} />
                    <Route path='/cdp/details' element={<ProtectedRoute><CDPDetails /></ProtectedRoute>} />
                    <Route path='/cdp/map' element={<ProtectedRoute><CDPMap/></ProtectedRoute>} />
                    <Route path='/cdp/singlecdpview' element={<ProtectedRoute><SingleCDPView/></ProtectedRoute>} />

                    {/* NHB PROTAL */}
                    <Route path='/nhb/dashboard' element={<ProtectedRoute><NHBDashboard /></ProtectedRoute>} />
                    <Route path='/nhb/details' element={<ProtectedRoute><NHBDetails /></ProtectedRoute>} />
                    <Route path='/nhb/map' element={<ProtectedRoute><NHBMap/></ProtectedRoute>} />
                    <Route path='/nhb/singlenhbview' element={<ProtectedRoute><SingleNHBView/></ProtectedRoute>} />

                    {/* MNT PROTAL */}
                    <Route path='/MNT/dashboardMnT' element={<ProtectedRoute><DashboardMnT /></ProtectedRoute>} />
                    <Route path='/MNT/AdmLogin' element={<ProtectedRoute><AdmLogin /></ProtectedRoute>} />
                    <Route path='/MNT/UsrListMnt' element={<ProtectedRoute><UsrListMnt /></ProtectedRoute>} />
                    <Route path='/MNT/FmtcUserCreation' element={<ProtectedRoute><FmtcUserCreation /></ProtectedRoute>} />
                    <Route path='/MNT/AtariUserCreation' element={<ProtectedRoute><AtariUserCreation /></ProtectedRoute>} />
                    <Route path='/MNT/CrmSurveyorCreation' element={<ProtectedRoute><CrmSurveyorCreation /></ProtectedRoute>} />
                    <Route path='/MNT/FmttiSurveyorCreation' element={<ProtectedRoute><FmttiSurveyorCreation /></ProtectedRoute>} />
                    <Route path='/MNT/KvkUserCreation' element={<ProtectedRoute><KvkUserCreation /></ProtectedRoute>} />
                    <Route path='/MNT/StateUser' element={<ProtectedRoute><StateUser /></ProtectedRoute>} />
                    <Route path='/MNT/DistrictUserCreation' element={<ProtectedRoute><DistrictUserCreation /></ProtectedRoute>} />
                    <Route path='/MNT/CHCDetailView' element={<ProtectedRoute><CHCDetailView /></ProtectedRoute>} />
                    <Route path='/MNT/SurveyorDetailView' element={<ProtectedRoute><SurveyorDetailView /></ProtectedRoute>} />
                    <Route path='/MNT/ExpMachineryDetailView' element={<ProtectedRoute><ExpMachineryDetailView /></ProtectedRoute>} />
                    <Route path='/MNT/SurveyDetail' element={<ProtectedRoute><SurveyDetail /></ProtectedRoute>} />
                    <Route path='/MNT/MachinSurveyReport' element={<ProtectedRoute><MachinSurveyReport /></ProtectedRoute>} />
                    <Route path='/MNT/IndividualCrmSurvey' element={<ProtectedRoute><IndividualCrmSurvey /></ProtectedRoute>} />
                    <Route path='/MNT/CRMCHCUpdatedData' element={<ProtectedRoute><CRMCHCUpdatedData /></ProtectedRoute>} />
                    <Route path='/MNT/updatedCRMCHCStateWise' element={<ProtectedRoute><UpdatedCRMCHCStateWise /></ProtectedRoute>} />
                    <Route path='/MNT/KVKWiseData' element={<ProtectedRoute><KVKWiseData /></ProtectedRoute>} />
                    {/* NewAdminPanel Protal */}
                    <Route path='/newadminpanel/dashboard' element={<NewAdminDashboard />} />
                    <Route path='/newadminpanel/selfAssignedTarget' element={<SelfAssignedTarget />} />
                    <Route path='/newadminpanel/allocatedcase' element={<AdminAllocatedcase />} />
                    <Route path='/newadminpanel/assetsNmeos' element={<AdminAssetsNmeo />} />
                    <Route path='/newadminpanel/assetsNmeop' element={<AdminAssetsNmeop />} />
                    <Route path='/newadminpanel/usercreation' element={<UserCreation />} />
                    <Route path='/newadminpanel/userlist' element={<UserList />} />
                    <Route path='/newadminpanel/farmer' element={<FarmerRouteElement />} />
                    <Route path='/newadminpanel/assignTarget' element={<AssignTarget />} />
                    <Route path='/scheme/nmeo-op/survey' element={<Survey />} />
                    <Route path="/newadminpanel/farmer/detailview" element={<FarmerDetailView/>}/>
                    <Route path="/newadminpanel/centrallogin" element={<CentralGT/>}/>
                    <Route path="/newadminpanel/companylogin" element={<CompanyGT/>}/>
                    <Route path="/newadminpanel/survey/detailview" element={<CropDetailView/>}/>
                    <Route path="/newadminpanel/geojson/view" element={<GeoJsonShow/>}/>
                    <Route path="/newadminpanel/NMEOOSDeatilPage" element={<NMEOOSDeatilPage/>}/>
                     {/* RKVY Seed Demonstration */}
                     <Route path='/newadminpanel/seedDemonstration' element={<SeedDemonstration />} />
                    <Route path='/newadminpanel/assetsReport' element={<AssetsReports />} />
                    <Route path='/newadminpanel/assetsReportOp' element={<AssetsReportOp />} />
                    {/* Testing Route */}
                    <Route path='/demo' element={<ProtectedRoute><Demo /></ProtectedRoute>} />
                    <Route path="/Downloads" element={<Downloads/>}/>
                    <Route path='/naturalfarminganalytic' element={<ProtectedRoute><MapHeader/><NaturalFarmingAnalytic /></ProtectedRoute>} />
                    <Route path="/km2" element={<Km2 />} />
                </Routes>
            </>
            </QueryClientProvider>
        );
    }
}
